import http from '../../../../libs/http'
const api = `${process.env.VUE_APP_MICROSERVICE_API_SHOPS}`
export default (payload = {}) => http.post(`${api}/suppliers/import-template-xls`, payload)
